<template>
  <div>
    <v-tabs v-model="active" color="white" slider-color="#587e27">
      <v-tab ripple key="addpage"><h5 class="earth">Add A Page</h5></v-tab>
      <v-tab ripple key="pages"><h5 class="earth">VIEW PAGES</h5></v-tab>
      <v-tab-item key="addpage">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <div class="card-header">
                  <h4 class="earth-color">Add Extra Page</h4>
                  <div class="title-decoration"></div>
                </div>
                <v-container>
                  <v-form @submit.prevent="postExtraPage()">
                    <v-text-field
                      label="Page Title"
                      v-model="page.name"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                    <label>Description</label>
                    <vue-editor v-model="page.description"></vue-editor>
                    <br/>
                    <v-btn 
                      depressed 
                      color="#587e27" 
                      block 
                      @click="postExtraPage()" 
                      class="futuristic-btn rounded-btn"
                    >
                      Publish
                    </v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <div class="card-header">
                  <h4 class="earth-color">Page Preview</h4>
                  <div class="title-decoration"></div>
                </div>
                <v-container>
                  <h2>{{page.name}}</h2>
                  <br>
                  <span v-html="page.description"></span>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item key="pages">
        <v-flex lg12 md12 sm12 xs12>
          <v-container>
            <v-card flat class="futuristic-card">
              <div class="card-header">
                <h4 class="earth-color">All Extra Pages</h4>
                <div class="title-decoration"></div>
              </div>
              <v-container class="table-container">
                <v-data-table
                  :headers="columns"
                  :items="allPages"
                  :search="search"
                  :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
                  :disable-initial-sort="true"
                  :loading="$loadingTrue"
                  class="futuristic-table"
                >
                  <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name}}</td>
                    <td>{{ props.item.page_type}}</td>
                    <td>{{ formated_date(props.item.created_at)}}</td>
                    <td v-if="props.item.status === 5">
                      <v-chip small color="#587e27" text-color="white" class="status-chip rounded-chip">
                        Active
                      </v-chip>
                    </td>
                    <td class="has-text-right">
                      <div class="action-buttons">
                        <v-btn 
                          depressed 
                          small 
                          color="#ff9800" 
                          @click="_editPage(props.item)" 
                          class="futuristic-btn rounded-btn action-btn"
                          v-if="edit === false"
                        >
                          Edit
                        </v-btn>
                        <v-btn 
                          depressed 
                          small 
                          color="#f44336" 
                          @click="_disablePage(props.item.public_id)" 
                          class="futuristic-btn rounded-btn action-btn"
                          v-if="edit === false"
                        >
                          Disable
                        </v-btn>
                        <v-btn 
                          depressed 
                          small 
                          color="#f44336" 
                          @click="pageResetInputs()" 
                          class="futuristic-btn rounded-btn action-btn"
                          v-if="edit === true"
                        >
                          Cancel Edit
                        </v-btn>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-container>
        </v-flex>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  name: 'add-page',
  components: {
    VueEditor
  },
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      sessionId: localStorage.getItem('lkjhgfdsa'),
      page: {
        name: '',
        page_type: 'normal',
        description: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      edit: false,
      editPage: {
        name: '',
        page_type: '',
        description: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      columns: [
        {
          text: 'Page Name',
          value: ''
        },
        {
          text: 'Page Type',
          value: ''
        },
        {
          text: 'Created At'
        },
        {
          text: 'Status'
        },
        {
          text: 'Action'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_page', 'normal')
    this.$store.dispatch('get_pages')
  },
  methods: {
    postExtraPage: function () {
      this.$store.dispatch('post_page', this.page)
    },
    _editPage: function (data) {
      this.editPage.name = data.name
      this.editPage.page_type = data.page_type
      this.editPage.description = data.description
      this.edit = true
    },
    editPostPage: function () {
      this.$store.dispatch('post_page', this.page)
    },
    _disablePage: function (publicId) {
      let _data = {
        deleted_by: this.sessionId,
        publicId: publicId
      }
      this.$store.dispatch('delete_page', _data)
    },
    pageResetInputs: function () {
      this.editPage.name = ''
      this.editPage.page_type = ''
      this.editPage.description = ''
      this.edit = false
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.earth {
  color: #587e27;
  font-weight: 500;
  text-transform: uppercase;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  height: 100%;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rounded-btn {
  border-radius: 24px !important;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.action-btn {
  min-width: auto;
  padding: 0 12px;
}

.rounded-chip {
  border-radius: 12px;
}

.status-chip {
  font-weight: 500;
}

.table-container {
  padding: 0;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Tabs styling */
.v-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  border-radius: 8px;
}

.v-tabs >>> .v-tabs__slider {
  background: #587e27 !important;
}

.vue-editor >>> .ql-container {
  border-radius: 8px;
  background: #f5f7fa;
  padding: 12px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }
  
  .card-header {
    padding: 12px;
  }
  
  .earth-color {
    font-size: 1.35rem;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }
  
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
  
  .action-btn {
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>